exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-8d091b32]{width:350px}.el-icon-plus[data-v-8d091b32]{margin-right:5px}.demo .el-switch__label[data-v-8d091b32]{position:absolute;display:none;color:#fff}.demo .el-switch__label--right[data-v-8d091b32]{z-index:1}.demo .el-switch__label--left[data-v-8d091b32]{z-index:1;left:19px}.demo .el-switch__label.is-active[data-v-8d091b32]{display:block}.demo.el-switch .el-switch__core[data-v-8d091b32],.el-switch .el-switch__label[data-v-8d091b32]{width:60px !important}.formBox .el-input-number--medium[data-v-8d091b32]{width:100px}", ""]);

// exports
